import { sortBy } from "lodash";
import { isPopulatedArray, isValidString } from "../../../components/helpers";
import { getUsersByRole } from "./_requests";
import { useQuery } from "react-query";

export const loadUsersQuery = (userType: string, productTypeId?: number) => ({
  queryKey: ['LOADUSERS', `${userType}`, productTypeId ? productTypeId : 0],
  queryFn: async () => getUsersByRole(userType, productTypeId).catch((err) => { console.warn(err); return null}),
  enabled: isValidString(userType),    
  staleTime: 600000,   // keep fresh for 10 mins (no refetch)  
  cacheTime: 600000,   // clear from cache after 10 mins to free mem  
})


export const loadUsersOptionsQuery = (userType: string, productTypeId?: number) => ({    
  ...loadUsersQuery(userType, productTypeId),
  select: (data: any) => (isPopulatedArray(data) ? sortBy( 
    data.map((o: any) => ({ value: o.id, text: o.name})), 
    [(o:any) => { return `${o.text}`.toLowerCase();}]
  ) : []),
});

export const returnUserData = (data: any) => (data && isPopulatedArray(data) ? data : []);

export const optionsFromUserData = (data: any) => (isPopulatedArray(data) ? sortBy( 
  data.map((o: any) => ({ value: o.id, text: o.name})), 
  [(o:any) => { return `${o.text}`.toLowerCase();}]
) : []);

type LoaderProps = {
  userType: string, 
  productTypeId?: number
  select?: (data:any) => any[] | null
}

export const useUserLoader = ({userType, productTypeId, select = optionsFromUserData} : LoaderProps) => {
  return useQuery({
    ...loadUsersQuery(userType, productTypeId),
    select
  })
}